import { KeyboardEvent } from 'react'

export function isKeyEnter(e: KeyboardEvent): boolean {
  return e.key.toLowerCase() === 'enter'
}
